import AutomateLoanDocsPage from 'pages/Loan/AutomateLoanDocs'

export default function AutomateLoanDocsClosingScreen() {
  return <AutomateLoanDocsPage hasOverview={false} />
}
